export const CLINIC_SWITCHER_TRANSLATIONS = {
  switched: {
    "pt-BR": "Organização Multi ativa alterada.",
    en: "Active Multi organization changed.",
    es: "Organización Multi activa cambiada.",
    de: "Aktive Multi-Organisation geändert.",
  },
  switchFailed: {
    "pt-BR": "Não foi possível trocar de clínica.",
    en: "Could not switch clinics.",
    es: "No se pudo cambiar de clínica.",
    de: "Konnte die Klinik nicht wechseln.",
  },
  ariaLabel: {
    "pt-BR": "Organização Multi ativa",
    en: "Active Multi organization",
    es: "Organización Multi activa",
    de: "Aktive Multiorganisation",
  },
  placeholder: {
    "pt-BR": "Organização",
    en: "Organization",
    es: "Organización",
    de: "Organisation",
  },
} as const;

export const CLINIC_MEMBERSHIP_LEAVE_TRANSLATIONS = {
  title: {
    "pt-BR": "Vínculo com a clínica",
    en: "Clinic membership",
    es: "Vínculo con la clínica",
    de: "Klinikmitgliedschaft",
  },
  subtitle: {
    "pt-BR": "{name} — solicite saída quando não fizer mais parte da equipe.",
    en: "{name} — request to leave when you are no longer part of the team.",
    es: "{name} — solicita la salida cuando ya no formes parte del equipo.",
    de: "{name} – Aufforderung zum Verlassen, wenn Sie nicht mehr Teil des Teams sind.",
  },
  organizationFallback: {
    "pt-BR": "Organização",
    en: "Organization",
    es: "Organización",
    de: "Organisation",
  },
  pending: {
    "pt-BR": "Saída solicitada — aguardando aprovação do administrador.",
    en: "Leave requested — waiting for administrator approval.",
    es: "Salida solicitada — esperando la aprobación del administrador.",
    de: "Urlaub beantragt – Warten auf Genehmigung durch den Administrator.",
  },
  cancelRequest: {
    "pt-BR": "Cancelar solicitação",
    en: "Cancel request",
    es: "Cancelar solicitud",
    de: "Anfrage abbrechen",
  },
  requestLeave: {
    "pt-BR": "Solicitar saída da clínica",
    en: "Request to leave the clinic",
    es: "Solicitar salida de la clínica",
    de: "Aufforderung, die Klinik zu verlassen",
  },
  requestSent: {
    "pt-BR": "Solicitação de saída enviada ao administrador.",
    en: "Leave request sent to the administrator.",
    es: "Solicitud de salida enviada al administrador.",
    de: "Urlaubsantrag an den Administrator gesendet.",
  },
  requestFailed: {
    "pt-BR": "Não foi possível solicitar saída.",
    en: "Could not request leave.",
    es: "No se pudo solicitar la salida.",
    de: "Konnte keinen Urlaub beantragen.",
  },
  cancelled: {
    "pt-BR": "Solicitação de saída cancelada.",
    en: "Leave request cancelled.",
    es: "Solicitud de salida cancelada.",
    de: "Urlaubsantrag storniert.",
  },
  cancelFailed: {
    "pt-BR": "Não foi possível cancelar a solicitação.",
    en: "Could not cancel the request.",
    es: "No se pudo cancelar la solicitud.",
    de: "Die Anfrage konnte nicht abgebrochen werden.",
  },
} as const;

export const CLINIC_LOGIN_PICKER_TRANSLATIONS = {
  title: {
    "pt-BR": "Selecione a organização",
    en: "Select the organization",
    es: "Selecciona la organización",
    de: "Wählen Sie die Organisation aus",
  },
  description: {
    "pt-BR": "Você participa de mais de uma organização Multi. Escolha qual deseja acessar agora.",
    en: "You belong to more than one Multi organization. Choose which one to access now.",
    es: "Participas en más de una organización Multi. Elige a cuál quieres acceder ahora.",
    de: "Sie gehören mehr als einer Multi-Organisation an. Wählen Sie aus, auf welches Sie jetzt zugreifen möchten.",
  },
  selectFailed: {
    "pt-BR": "Não foi possível selecionar a organização.",
    en: "Could not select the organization.",
    es: "No se pudo seleccionar la organización.",
    de: "Die Organisation konnte nicht ausgewählt werden.",
  },
} as const;

export const CLINIC_ACTING_PROFESSIONAL_TRANSLATIONS = {
  label: {
    "pt-BR": "Profissional em atendimento",
    en: "Professional on duty",
    es: "Profesional en atención",
    de: "Professionell im Dienst",
  },
  placeholder: {
    "pt-BR": "Selecione o profissional",
    en: "Select the professional",
    es: "Selecciona el profesional",
    de: "Wählen Sie den Fachmann aus",
  },
  hint: {
    "pt-BR": "Selecione um profissional para liberar o acesso clínico.",
    en: "Select a professional to unlock clinical access.",
    es: "Selecciona un profesional para liberar el acceso clínico.",
    de: "Wählen Sie einen Fachmann aus, um den klinischen Zugang freizuschalten.",
  },
  selected: {
    "pt-BR": "Profissional selecionado.",
    en: "Professional selected.",
    es: "Profesional seleccionado.",
    de: "Professionell ausgewählt.",
  },
  changeFailed: {
    "pt-BR": "Não foi possível alterar o profissional.",
    en: "Could not change the professional.",
    es: "No se pudo cambiar el profesional.",
    de: "Konnte den Fachmann nicht wechseln.",
  },
} as const;

export const CLINIC_TAX_IDENTITY_TRANSLATIONS = {
  email: { "pt-BR": "E-mail", en: "Email", es: "Correo" , de: "E-Mail"},
  taxTypeLabel: {
    "pt-BR": "Tipo de documento *",
    en: "Document type *",
    es: "Tipo de documento *",
    de: "Dokumenttyp *",
  },
  taxTypeAria: {
    "pt-BR": "Tipo de documento",
    en: "Document type",
    es: "Tipo de documento",
    de: "Dokumenttyp",
  },
  taxTypePlaceholder: {
    "pt-BR": "Selecione CPF ou CNPJ",
    en: "Select CPF or CNPJ",
    es: "Selecciona CPF o CNPJ",
    de: "Wählen Sie CPF oder CNPJ",
  },
  cnpjOption: {
    "pt-BR": "CNPJ (pessoa jurídica)",
    en: "CNPJ (legal entity)",
    es: "CNPJ (persona jurídica)",
    de: "CNPJ (juristische Person)",
  },
  cpfOption: {
    "pt-BR": "CPF (profissional autônomo / clínica unipessoal)",
    en: "CPF (sole practitioner / single-person clinic)",
    es: "CPF (profesional autónomo / clínica unipersonal)",
    de: "CPF (Einzelarzt / Einzelklinik)",
  },
  clinicName: {
    "pt-BR": "Nome da clínica *",
    en: "Clinic name *",
    es: "Nombre de la clínica *",
    de: "Klinikname *",
  },
  responsibleCpf: {
    "pt-BR": "CPF do responsável",
    en: "Responsible person's CPF",
    es: "CPF del responsable",
    de: "CPF der verantwortlichen Person",
  },
  clinicCnpj: {
    "pt-BR": "CNPJ da clínica *",
    en: "Clinic CNPJ *",
    es: "CNPJ de la clínica *",
    de: "Klinik CNPJ *",
  },
  clinicPhone: {
    "pt-BR": "Telefone da clínica",
    en: "Clinic phone",
    es: "Teléfono de la clínica",
    de: "Telefon der Klinik",
  },
  nameRequired: {
    "pt-BR": "Informe o nome da clínica.",
    en: "Enter the clinic name.",
    es: "Indica el nombre de la clínica.",
    de: "Geben Sie den Kliniknamen ein.",
  },
  phoneInvalid: {
    "pt-BR": "Telefone inválido.",
    en: "Invalid phone number.",
    es: "Teléfono inválido.",
    de: "Ungültige Telefonnummer.",
  },
} as const;

export const CNPJ_VALIDATION_TRANSLATIONS = {
  taxTypeRequired: {
    "pt-BR": "Informe se o documento é CPF ou CNPJ.",
    en: "Specify whether the document is CPF or CNPJ.",
    es: "Indica si el documento es CPF o CNPJ.",
    de: "Geben Sie an, ob es sich bei dem Dokument um CPF oder CNPJ handelt.",
  },
  taxIdRequired: {
    "pt-BR": "Informe o CPF ou CNPJ da clínica.",
    en: "Enter the clinic CPF or CNPJ.",
    es: "Indica el CPF o CNPJ de la clínica.",
    de: "Geben Sie die Klinik CPF oder CNPJ ein.",
  },
  cpfInvalid: { "pt-BR": "CPF inválido.", en: "Invalid CPF.", es: "CPF inválido." , de: "Ungültiger CPF."},
  cnpjInvalid: { "pt-BR": "CNPJ inválido.", en: "Invalid CNPJ.", es: "CNPJ inválido." , de: "Ungültiges CNPJ."},
} as const;

export const CLINIC_CHECKOUT_HOLDER_TRANSLATIONS = {
  cnpjInvalid: {
    "pt-BR": "Informe um CNPJ válido do responsável pelo pagamento.",
    en: "Enter a valid CNPJ for the payment holder.",
    es: "Indica un CNPJ válido del responsable del pago.",
    de: "Geben Sie einen gültigen CNPJ für den Zahlungsinhaber ein.",
  },
  cpfInvalid: {
    "pt-BR": "Informe um CPF válido do responsável pelo pagamento.",
    en: "Enter a valid CPF for the payment holder.",
    es: "Indica un CPF válido del responsable del pago.",
    de: "Geben Sie einen gültigen CPF für den Zahlungsinhaber ein.",
  },
} as const;

export const WORK_SCHEDULE_DAY_TRANSLATIONS = {
  sunday: { "pt-BR": "Domingo", en: "Sunday", es: "Domingo" , de: "Sonntag"},
  monday: { "pt-BR": "Segunda-feira", en: "Monday", es: "Lunes" , de: "Montag"},
  tuesday: { "pt-BR": "Terça-feira", en: "Tuesday", es: "Martes" , de: "Dienstag"},
  wednesday: { "pt-BR": "Quarta-feira", en: "Wednesday", es: "Miércoles" , de: "Mittwoch"},
  thursday: { "pt-BR": "Quinta-feira", en: "Thursday", es: "Jueves" , de: "Donnerstag"},
  friday: { "pt-BR": "Sexta-feira", en: "Friday", es: "Viernes" , de: "Freitag"},
  saturday: { "pt-BR": "Sábado", en: "Saturday", es: "Sábado" , de: "Samstag"},
} as const;
